import { useContext } from 'react';
import { Grid, Typography } from '@mui/material';
import { orderContext } from '../OrderContext';
import { DetailsPageHeader } from 'components';


let Customer = () => {
    let service = useContext(orderContext);

    return (
        <DetailsPageHeader sectionName='Customer'>
            {service.order.customer &&
                <Grid container>
                    <Grid item xs={3}>
                        <Typography>Email</Typography>
                    </Grid>
                    <Grid item xs={9}>
                        <Typography>{service.order.customer.email}</Typography>
                    </Grid>
                    <Grid item xs={3}>
                        <Typography>Name</Typography>
                    </Grid>
                    <Grid item xs={9}>
                        <Typography>{service.order.customer.firstName}&nbsp;{service.order.customer.lastName}</Typography>
                    </Grid>
                    <Grid item xs={3}>
                        <Typography>Creatio Id</Typography>
                    </Grid>
                    <Grid item xs={9}>
                        <Typography>{service.order.customer.creatioId}</Typography>
                    </Grid>
                    <Grid item xs={3}>
                        <Typography>Groups</Typography>
                    </Grid>
                    <Grid item xs={9}>
                        <Typography>{service.order.customer.customerGroups}</Typography>
                    </Grid>
                </Grid>
            }
        </DetailsPageHeader>
    );
}

export default Customer;